import { CreateCompanyDetailsInput, CreatecompanydetailsMutationVariables } from "../../../graphql";
import { CompanyDetails } from "../../../types";

export function createCompanyDetailsPayloadFromCompanyDetails(updateDetails: CompanyDetails,emailaddress:string,phonenumber:string): CreatecompanydetailsMutationVariables {
  const input: CreateCompanyDetailsInput = {
    companyshort: updateDetails.companyshort!,
    companylegalname: updateDetails.companylegalname!,
    lutbondtodate: updateDetails.lutbondtodate!,
    invoicedetailapplicablefromdate: updateDetails.invoicedetailapplicablefromdate!,
    tdsapplicable: updateDetails.tdsapplicable!,
    gstcategory: updateDetails.gstcategory!,
    financialyearstartandendmonth: updateDetails.financialyearstartandendmonth!,
    expiredtimestamp: updateDetails.expiredtimestamp!,
    websiteurl: updateDetails.websiteurl!,
    currencycd: updateDetails.currencycd!,
    accountinventoryflag: updateDetails.accountinventoryflag!,
    pannumber: updateDetails.pannumber!,
    tdstcsnumber: updateDetails.tdstcsnumber!,
    cinregistrationnumber: updateDetails.cinregistrationnumber!,
    registrationtype: updateDetails.registrationtype!,
    comppercentage: updateDetails.comppercentage!,
    gstrperiod: updateDetails.gstrperiod!,
    lut: updateDetails.lut!,
    lutbondvalidfrom: updateDetails.lutbondvalidfrom!,
    ewaybillflag: updateDetails.ewaybillflag!,
    gstapplicablefrom: updateDetails.gstapplicablefrom!,
    thresholdlimitcd: updateDetails.thresholdlimitcd!,
    thresholdlimitamount: updateDetails.thresholdlimitamount!,
    companylogourl: updateDetails.companylogourl!,
    msmetype: updateDetails.msmetype!,
    udhyamregno: updateDetails.udhyamregno!,
    udhyamdocs: updateDetails.udhyamdocs!,
    ewaybillstartdate: updateDetails.ewaybillstartdate!,
    minamountewayinter: updateDetails.minamountewayinter!,
    minamountewayintra: updateDetails.minamountewayintra!,
    einvoiceflag: updateDetails.einvoiceflag!,
    einvoicestartingdate: updateDetails.einvoicestartingdate!,
    gstcompensationcessflag: updateDetails.gstcompensationcessflag!,
    tradelicensenumber: updateDetails.tradelicensenumber!,
    tradelicensestartdate: updateDetails.tradelicensestartdate!,
    tradelicenseenddate: updateDetails.tradelicenseenddate!,
    cinregistrationdate: updateDetails.cinregistrationdate!,
    lastupdatedtimestamp: updateDetails.lastupdatedtimestamp!,
    einvoiceconnect: updateDetails.einvoiceconnect!,
    ewaybillconnect: updateDetails.ewaybillconnect!,
    financialyearid: updateDetails.financialyearid!,
    stepscompleted: JSON.stringify(['step 1', 'step 2']),
    emailaddress:emailaddress,
    phonenumber:phonenumber
  };

  return {
    createCompanyDetailsInput: [input],
  };
}
